import React, { useState } from "react";
import { Mail, ArrowRight, Check } from "lucide-react";

// Shown after a listener finishes the narrated sample.
export const ListenerNudge = ({ onSubscribe }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("sending");
    const res = await onSubscribe(email);
    if (res?.ok === false) { setState("idle"); return; }
    try { localStorage.setItem("aip_subscribed", "1"); } catch (err) { void err; }
    setState("done");
  };

  if (state === "done") {
    return (
      <div className="fade-in-quick mb-8 rounded-2xl border border-emerald-400/30 bg-emerald-500/10 p-5 flex items-center gap-3" data-testid="listener-nudge-done">
        <Check className="w-5 h-5 text-emerald-300 shrink-0" />
        <p className="text-emerald-100 text-sm">You're on the list. The next chapter is headed your way.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="fade-in-quick mb-8 rounded-2xl border border-cyan-400/30 bg-gradient-to-br from-cyan-500/10 to-purple-500/10 p-5" data-testid="listener-nudge">
      <p className="font-orbitron text-[10px] tracking-[0.3em] uppercase text-cyan-300 mb-1 flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> Want to hear what happens next?</p>
      <p className="text-white text-base md:text-lg mb-4" style={{ fontFamily: "Georgia, serif" }}>Get the next chapter sent straight to your inbox.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="flex-1 px-4 py-3 rounded-full bg-black/40 border border-white/15 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-400/60"
          data-testid="listener-nudge-email"
        />
        <button type="submit" disabled={state === "sending"} className="btn-gradient text-white px-6 py-3 rounded-full font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="listener-nudge-submit">
          {state === "sending" ? "Sending…" : <>Send it <ArrowRight className="w-4 h-4" /></>}
        </button>
      </div>
      <p className="text-gray-500 text-xs mt-2">You'll also get The Awakening Journal updates. No spam. Unsubscribe anytime.</p>
    </form>
  );
};
